/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Debt_Amount_PositiveInputs */

const en_case_validation_debt_amount_positive = /** @type {(inputs: Case_Validation_Debt_Amount_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debt amount must be greater than zero.`)
};

const pt_br2_case_validation_debt_amount_positive = /** @type {(inputs: Case_Validation_Debt_Amount_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor do débito deve ser maior que zero.`)
};

/**
* | output |
* | --- |
* | "Debt amount must be greater than zero." |
*
* @param {Case_Validation_Debt_Amount_PositiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_debt_amount_positive = /** @type {((inputs?: Case_Validation_Debt_Amount_PositiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Debt_Amount_PositiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_debt_amount_positive(inputs)
	return pt_br2_case_validation_debt_amount_positive(inputs)
});